import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedTableName: "",
};

const selectedTableSlice = createSlice({
  name: "selectedTable",
  initialState,
  reducers: {
    setSelectedTableName: (state, action) => {
      state.selectedTableName = action.payload ?? "";
    },
    clearSelectedTableName: state => {
      state.selectedTableName = "";
    },
  },
});

export const { setSelectedTableName, clearSelectedTableName } =
  selectedTableSlice.actions;
export default selectedTableSlice.reducer;
